import React from 'react';
import { useNavigate } from 'react-router-dom';
import EyeIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { useSelector } from 'react-redux';

import { API_DOMAIN } from '../../../../constants';
import { ICartItem } from '../interfaces';
import { thousands } from '../../../../utils/utils';
import { useCartItemsStyles } from '../hooks/useCartItemsStyles.';
import { useFormatMessage } from '../../../../hooks';
import { CartCounter } from './CartCounter';
import { calculatePrice } from '../utils';
import { selectIsAdmin } from '../selectors';

const CartItem: React.FC<{
  setProductCount: (data: { product_id: number; count: number; vendor_id?: number }) => void;
  handleImage?: (url?: string) => void;
  itemCart: ICartItem;
  isLastItem?: boolean;
}> = ({ setProductCount, handleImage, itemCart, isLastItem }) => {
  const classes = useCartItemsStyles();
  const navigate = useNavigate();
  const fm = useFormatMessage();
  const isAdmin = useSelector(selectIsAdmin);
  const priceData = calculatePrice(itemCart.count, itemCart.prices);
  const price = priceData || itemCart.product.price || 0;

  return (
    <div className={classes.cardContent}>
      <div
        className={classes.contentWrapper}
        style={{
          borderBottom: isLastItem ? 'none' : '1px solid #7c97c033',
        }}
      >
        <div className={classes.containerImage}>
          {itemCart.product.photos && itemCart.product.photos.length > 0 ? (
            <img
              alt=''
              onClick={() =>
                itemCart.product.photos &&
                handleImage &&
                handleImage(
                  `${API_DOMAIN}/${
                    itemCart?.product?.photos?.find(el => el.main)?.small ||
                    itemCart.product.photos[0].small ||
                    ''
                  }`
                )
              }
              src={`${API_DOMAIN}/${
                itemCart?.product?.photos?.find(el => el.main)?.small ||
                itemCart.product.photos[0].small
              }`}
              className={classes.img}
            />
          ) : (
            <img alt='' src='../../../images/placeholder.png' className={classes.img} />
          )}
        </div>

        <div className={classes.infoWrapper}>
          <div className={classes.cardTopRow}>
            <div
              className={classes.deleteButtonCorner}
              onClick={() => {
                setProductCount({
                  product_id: itemCart.product.id || 0,
                  count: 0,
                  vendor_id: itemCart.vendor_id,
                });
              }}
            >
              <DeleteIcon sx={{ fontSize: 19, color: '#7c97c0' }} />
              <b className={classes.btnIconTitle}>{fm('COMMON.BUTTON.DELETE')}</b>
            </div>
          </div>
          <div className={classes.infoButtonsWrapper}>
            <div className={classes.containerProduct}>
              <b className={classes.productName}>{itemCart.product.name}</b>
              <div className={classes.containerPrice}>
                <b className={classes.priceProduct}>{`${price} ₽ x ${itemCart.count} шт =`}</b>
                <b className={classes.priceTotal}>
                  {price * itemCart.count === 0
                    ? 0
                    : thousands(String((price * itemCart.count).toFixed(2)))}{' '}
                  руб.
                </b>
              </div>
            </div>

            <div className={classes.buttonsWrapper}>
              <div
                className={classes.containerButton}
                onClick={() => {
                  navigate(
                    isAdmin
                      ? `/products/edit/${itemCart.product.id}`
                      : `/viewproduct/${itemCart.product.id}`
                  );
                }}
              >
                <EyeIcon sx={{ fontSize: 19, color: '#7c97c0' }} />
                <b className={classes.btnIconTitle}>{fm('VIEW')}</b>
              </div>
              <CartCounter item={itemCart} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
